// extracted by mini-css-extract-plugin
export default {"container":"ErrorMessage_container__aH0y7","text":"ErrorMessage_text__oNIkA"};